<template>
  <v-form
    ref="addConfiguration"
    id="addConfiguration"
    class="text-capitalize"
    v-model="valid"
    lazy-validation
    @submit.prevent="addConfiguration"
  >
    <div v-if="errors.length > 0">
      <p class="subtitle-1 error--text">Errors</p>
      <ul>
        <li v-for="(error, i) in errors" :key="i" class="error--text text-capitalize">
          {{ error }}
        </li>
      </ul>
    </div>
    <v-text-field
      name="key"
      label="Config Name (Key)"
      v-model="key"
      outlined
      :rules="commonRules"
    ></v-text-field>
    <v-text-field
      name="value"
      label="Config Value"
      v-model="value"
      outlined
      :rules="commonRules"
    ></v-text-field>
    <v-btn
      color="primary"
      large
      raised
      tile
      block
      type="submit"
      form="addConfiguration"
      :loading="loading"
      >Add Configuration</v-btn
    >
  </v-form>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      loading: false,
      value: "",
      key: "",
      errors: [],
      commonRules: [(v) => !!v || "This field is required"],
    };
  },
  methods: {
    addConfiguration() {
      if (!this.$refs.addConfiguration.validate()) {
        this.loading = false;
        window.Notify.error("There are some fields with errors.");
        return;
      }
      this.loading = true;
      const url = "api/v1/config";
      const data = {
        value: this.value,
        key: this.key,
      };
      // create transaction
      this.$http
        .post(url, { ...data })
        .then((response) => {
          this.loading = false;
          window.Notify.success(response.message);
          // reset form
          this.$refs.addConfiguration.reset();
          // close dialog
          this.$emit("configAdded");
        })
        .catch((error) => {
          this.loading = false;
          window.Notify.error(this.getErrorMessage(error));
        });
    },
    getErrorMessage(error) {
      const response = error.response ? error.response : {},
        status = response.status ? response.status : 0;
      const genError = "There was an error.";
      let message = response.data ? response.data.message : genError;
      if (status === 422) {
        for (let key in response.data.errors) {
          if (response.data.errors.hasOwnProperty(key)) {
            this.errors.push(response.data.errors[key]);
          }
        }
      }
      return message;
    },
  },
};
</script>
